import { formatCurrency } from "../formatCurrency/index.js";

export const formatDiscountAmount = (
  discount: {
    type: "percentage" | "perpetual-flat" | "flat";
    amount: number;
  },
  currency?: string,
): string => {
  if (discount.type === "percentage") return `${discount.amount}%`;
  else return `${formatCurrency(discount.amount, currency)}`;
};
